export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9744.a85fab0b.jpg";